var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTeDhenatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.135,
    height: 30.769,
    viewBox: "0 0 33.135 30.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7a30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0a13d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "te_dhenat",
    "data-name": "te dhenat",
    transform: "translate(-1 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3726",
    "data-name": "Path 3726",
    d: "M19.934,23.4V21.446c2.608-1.47,4.734-5.131,4.734-8.8,0-5.882,0-10.651-7.1-10.651s-7.1,4.769-7.1,10.651c0,3.664,2.125,7.325,4.734,8.8V23.4C7.173,24.054,1,28,1,32.769H34.135C34.135,28,27.963,24.054,19.934,23.4Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeDhenatIcon);
export default __webpack_public_path__ + "static/media/teDhenatIcon.6452ee063b5ad8e008a25bc0dbfba683.svg";
export { ForwardRef as ReactComponent };